module.exports = __webpack_public_path__ + "img/k9.32de886f.jpg";